import $ from 'jquery';
import Results from './results.js';

/* Page
 *
 * Sets specific states search can be in (loading/fail/
 * success/etc), puts results in page and sets active
 * product.
 *
 * VERY tightly coupled to the layout and elements
 * of our current search page.
 */
class Page {
  constructor() {
    this.results  = new Results('.js-search-results-entries', []);

    this.elems = {
      product: $('.js-product'),
      section: $('.js-search-results'),
      count: $('.js-search-results-number'),
    };

    this.prefix = 'is-';
    this.states = ['nil', 'loading', 'success', 'none', 'fail', 'exceed', 'over'];

    this.setState('nil');
  }

  setState(state) {
    this.states.map( (c) => {
      this.elems.section.removeClass(this.prefix + c);
    } );

    this.elems.section.addClass(this.prefix + state);
    window.scrollTo(0,0);
  }

  build(list) {
    const entries = list.map( (doc) => this.results.entry(doc) ).join('');

    return entries;
  }

  // STATES
  // states the page can be in
  loading(query, product, docTypes) {
    const urlParams = new URLSearchParams(window.location.search);

    product = product.replace('-PREP', '');

    this.elems.product.removeClass('is-active');
    this.elems.product.filter(`[data-product-id="${product.toLowerCase()}"]`).addClass('is-active');

    urlParams.set('Product', product);
    urlParams.set('query', query);
    urlParams.set('doc-types', docTypes);

    // const queryString = `?Product=${product}&query=${query}&doc-types=${docTypes}`;
    history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());

    this.results.reset();
    this.setState('loading');
  }

  success(list, count) {
    let entries = this.build(list);
    this.elems.count.html(count);

    this.setState('success');
    this.results.set(entries);
  }

  over(list) {
    const slicedList = list.slice(0, 7);
    let entries = this.build(slicedList);

    this.setState('over');
    this.results.set(entries);
  }

  exceed() {
    this.setState('exceed');
  }

  none() {
    this.setState('none');
  }


  fail() {
    this.setState('fail');
  }

  // Debug info
  debug(result) {
    const { status, data, meta, message, trimmed } = result;
    const $debugContainer = $('.js-search-debug-info');

    if ( !$debugContainer.length ) {
      return;
    }

    $debugContainer.html('');

    if ( status ) {
      $debugContainer.append(`<h3>Status: ${status}</h3>`);
    }

    if ( message ) {
      $debugContainer.append(`<h3>Message: ${message}</h3>`);
    }

    if ( meta ) {
      if ( meta.hasOwnProperty('page') && meta['page'].hasOwnProperty('total_results') ) {
        $debugContainer.append(`<h3>Total results: ${meta['page']['total_results']}</h3>`);
      }
    }

    if ( data && data.length ) {
      $debugContainer.append('<h3>Results:</h3>');
      const toSkip = ['_meta', 'file', 'path', 'files', 'url', 'es_doc_type'];
      this.table($debugContainer, data, toSkip, 7);
    }

    if ( trimmed && trimmed.length ) {
      $debugContainer.append('<hr>');
      $debugContainer.append('<h4>Trimmed by score:</h4>');
      const toSkip = ['_meta', 'file', 'path', 'files', 'url', 'es_doc_type'];
      this.table($debugContainer, trimmed, toSkip);
    }
  }

  table($debugContainer, data, toSkip, maxLen) {
    data.forEach((dataItem, index) => {

      if (maxLen && index === maxLen) {
        $debugContainer.append($(`<h4>Beyond ${maxLen}th:</h4>`));
      }

      const $tableContainer = $('<div class="table-container"></div>');
      const $table = $('<table></table>');
      const $thead = $('<thead></thead>');
      const $tbody = $('<tbody></tbody>');
      const $tr = $('<tr></tr>');
      const objectKeys = Object.keys(dataItem);

      // Add ['_meta']['score'] as first table item
      $thead.append('<th>score</th>');
      $tr.append(`<td>${dataItem['_meta']['score']}</td>`);
      
      // Add ['_meta']['es_doc_type'] as second table item
      $thead.append('<th>type</th>');
      $tr.append(`<td>${dataItem['es_doc_type']['raw']}</td>`);

      // Table head
      for (const key of objectKeys) {
        if (toSkip.includes(key)) { continue; }
        const $th = $(`<th>${key}</th>`);

        $thead.append($th);
      }

      // Table body
      for (const key in dataItem) {
        if (toSkip.includes(key)) { continue; }
        const $td = $(`<td>${dataItem[key]['raw']}</td>`);

        $tr.append($td);
      }

      // Add url/file as third table item
      let atag = this.dataItemUrl(dataItem);
      $thead.find('th:nth-child(2)').after('<th>url</th>');
      $tr.find('td:nth-child(2)').after(`<td>${atag}</td>`);

      $tbody.append($tr);
      $table.append($thead, $tbody);
      $tableContainer.append($table);
      $debugContainer.append($tableContainer);
    });
  }

  dataItemUrl(dataItem) {
    let url = '';

    if ( dataItem.hasOwnProperty('url') ) {
      url = dataItem['url']['raw'];
    } else if ( dataItem.hasOwnProperty('files') ) {
      let files = JSON.parse(dataItem['files']['raw']);
      url = `https://www.askgileadmedical.com${files.file}`;
    } else if ( dataItem.hasOwnProperty('path') ) {
      url = `https://www.askgileadmedical.com/docs/${dataItem['path']['raw']}`;
    }

    return `<a href="${url}" target="_blank">${url}</a>`;
  }

}

export default Page;



// WEBPACK FOOTER //
// ./src/assets/js/project/search/page.js